import { getLengthWithSpecialSymbols } from '@gem/utils';

import type { IFieldValidationParams } from '../validation.types';
import { ValidationErrorType } from '../validation.types';

const MARKET_NAME_MIN_LENGTH = 2;

export const spaceMarketNameValidation = ({
  value,
  errorToText,
}: IFieldValidationParams): string | null => {
  if (!value || value.length === 0) {
    return errorToText[ValidationErrorType.Empty] || '';
  }

  if (getLengthWithSpecialSymbols(value) < MARKET_NAME_MIN_LENGTH) {
    return errorToText[ValidationErrorType.TooShort] || '';
  }

  return null;
};
